import {Grid} from '@logistics-frontend/blocks'
import {makeStyles} from '@material-ui/core/styles'
import {useField} from '@yandex-taxi/react-integration-api'
import React, {useEffect} from 'react'

import {useMaxRoutePoints} from 'src/components/hooks'
import {useMapRoute as useRoute, useSetBoundsSettings} from 'src/components/map-bounds'

import {AddAddressButton} from './AddAddresButton'
import Address from './Address'

const useClasses = makeStyles(theme => ({
  addAdress: {
    padding: theme.spacing(1.5, 0, 1, 0),
  },
}))

const Route: React.FC = () => {
  const classes = useClasses()
  const setBoundsSettings = useSetBoundsSettings()
  const [{value: route = []}, {remove, clear}] = useRoute()
  const [, {setValue: setRoute}] = useField(['route'])
  const maxRoutePoints = useMaxRoutePoints()

  useEffect(() => {
    const diff = route.length - maxRoutePoints
    if (diff > 0) {
      setRoute(route.slice(0, route.length - diff))
      setBoundsSettings({shouldBounds: true})
    }
  }, [route, maxRoutePoints, setRoute, setBoundsSettings])

  return (
    <>
      {route.map((_, index, origin) => (
        <Address key={index} index={index} length={origin.length} onClear={clear} onRemove={remove} />
      ))}
      <Grid className={classes.addAdress} spacing={1} container>
        <Grid xs={12} item>
          <AddAddressButton />
        </Grid>
      </Grid>
    </>
  )
}

export default Route
